module.exports = __webpack_public_path__ + "static/media/FOTM_LOGO_DARK.a8fbf25d.png";